import OfferDetail from './styled';

export default OfferDetail;
